export const USER_ROLE = {
  CLIENT: 'client',
  ADMIN: 'admin',
  ADMIN_VERIFY: 'adminVerify',
  SUPER_ADMIN: 'superAdmin',
};

export const USER_ROLE_FLAGS = {
  [USER_ROLE.CLIENT]: { isAdmin: false, isSuperAdmin: false, canVerify: false },
  [USER_ROLE.ADMIN]: { isAdmin: true, isSuperAdmin: false, canVerify: false },
  [USER_ROLE.ADMIN_VERIFY]: { isAdmin: true, isSuperAdmin: false, canVerify: true },
  [USER_ROLE.SUPER_ADMIN]: { isAdmin: true, isSuperAdmin: true, canVerify: true },
};

export function flagsFromUserRole(role) {
  return USER_ROLE_FLAGS[role] || USER_ROLE_FLAGS[USER_ROLE.CLIENT];
}

export function userRoleFromFlags({ isAdmin, isSuperAdmin, canVerify }) {
  if (isSuperAdmin) return USER_ROLE.SUPER_ADMIN;
  if (isAdmin && canVerify) return USER_ROLE.ADMIN_VERIFY;
  if (isAdmin) return USER_ROLE.ADMIN;
  return USER_ROLE.CLIENT;
}
